import { string, boolean, object, date } from "yup";

export const documentReference = object();

export const stringDefaultToEmpty = string()
  .nullable()
  .default(() => "");

export const booleanDefaultToFalse = boolean().default(() => false);

export const firebaseDate = date().transform(
  (value, originalValue, context) => {
    // check to see if the previous transform already parsed the date
    if (context.isType(value)) return value;

    // firebase date object requires toDate to be called
    // to convert it to a valid date object
    value = originalValue?.toDate();

    // if it's valid return the date object, otherwise return an `InvalidDate`
    return value || new Date();
  }
);
